import React from 'react';
import styled from 'styled-components';
import Up from '../../assets/up.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';


const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height: 50vh;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(11,76,181,0.8);
  position: relative;

  
`;

const Coverbg = styled.img`
  position: absolute;
  max-height: 100%;
  min-width: 100%;
  object-fit: contain;
  align-self:center; 
  border: none;
`;

class CardComposition extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
    
      <Coverbg src= {'https://cdn.slidesharecdn.com/ss_thumbnails/compositionofair-090714002610-phpapp01-thumbnail-4.jpg?cb=1247531194'}/>        
    
      
            
    </Viz>

      <ReusableDetailCard
   trend= {Up}
   metricsm="Increasing CO2"
   diagnosis="By volume, dry air contains 78.08% nitrogen, 20.95% oxygen, 0.93% argon, 0.04% carbon dioxide, and small amounts of other gases."
   prediction="Increasing concentrations of these gasses are trapping too much heat in the atmosphere and overloading Earth's natural processes, such as the carbon cycle."
   significanceorthreat="SIGNIFICANCE"
   confidence="CONFICENCE LV: 95%"
   />
  </Container>
  );
 }
}

export default CardComposition;
